<template>
  <div class="flex">
    <span
      v-if="
        badgeProps.variant === 'perGroupUpTo' && badgeProps.maxPeople != null
      "
      class="text-label text-gray-500"
    >
      {{
        t('product.show.checkout.perGroupUpTo', { max: badgeProps.maxPeople })
      }}
    </span>
    <Badge
      v-else-if="badgeProps.variant === 'multidate'"
      class="bg-teal-50 text-primary m-0"
    >
      {{
        t('product.show.checkout.multidateBadge', {
          count: badgeProps.sessionCount,
        })
      }}
    </Badge>
    <Tooltip
      v-else-if="
        badgeProps.variant === 'private' || badgeProps.variant === 'info'
      "
      :key="badgeProps.tooltipText"
      :tooltip-text="badgeProps.tooltipText"
      length="large"
      position="down"
      type="span"
    >
      <Badge
        v-if="badgeProps.variant === 'private'"
        class="bg-teal-50 text-primary m-0"
      >
        {{ t('product.show.checkout.buyBoxPrivateBadge') }}
      </Badge>
      <InfoCircleFill v-else class="text-gray-500" />
    </Tooltip>
  </div>
</template>

<script lang="ts" setup>
import InfoCircleFill from '~/assets/icons/info-circle-fill.svg?component'
import type { BadgeProps } from '~/composables/eventBuyBoxPrice'

defineProps<{
  badgeProps: BadgeProps
}>()

const { t } = useI18n()
</script>
